// Ukrainian dictionary — keep structurally identical to en.js.
const uk = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Відчуйте бадмінтонні турніри в прекрасному місті Тренчин',
    info: 'INFO',
    book: 'ЗАБРОНЮВАТИ ЖИТЛО',
  },

  home: {
    upcomingTitle: 'Найближчі події у 2026 році',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Незабаром',
    eventDateShort: '25–27 вересня',
  },

  tournament: {
    entryDeadline: 'Кінцевий термін заявок:',
    upcoming: 'Незабаром',
    deadlineU17: '25 серпня 2026',
    deadlineU13: '11 вересня 2026',
    eventDate: '25–27 вересня 2026',
    invitation: 'ЗАПРОШЕННЯ',
    register: 'РЕЄСТРАЦІЯ',
    draws: 'ЖЕРЕБКУВАННЯ',
    acceptanceList: 'СПИСОК УЧАСНИКІВ',
    infoTitle: 'Інформація про турнір',
    entryFees: 'Стартовий внесок:',
    singles25: 'Одиночний розряд = 25 €',
    singles40: 'Одиночний розряд = 40 €',
    doubles20: 'Парний розряд = 20 € / гравець',
    doubles30: 'Парний розряд = 30 € / гравець',
    feesPayment: 'Стартовий внесок сплачується банківським переказом до турніру або готівкою (EUR) організатору під час турніру.',
    shuttlesLabel: 'Офіційні волани турніру:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'На кожен матч надається 2 волани, решту учасники забезпечують самостійно. Волани KAWASAKI SHUTTLECOCK TEAM 1 можна придбати в організаторів.',
    managersMeeting: 'Нарада керівників команд:',
    meetingU17: 'Четвер, 24 вересня 2026, о 19:00 у залі.',
    mainEvent: 'Основний турнір',
    finals: 'Фінали',
    provisionalNote: 'ⓘ Попередній розклад може змінитися залежно від кількості заявок. Остаточний розклад (із точним запланованим завершенням усіх матчів) буде опубліковано на сайті щонайпізніше за 20 днів до початку турніру.',
    seedingNote: 'Посів і жеребкування проведено згідно з рейтингом BEC European U17 від 17 вересня.',
    koSystemNote: 'Одиночні розряди на першому етапі граються у групах, далі — за олімпійською системою (на виліт); парні розряди граються за олімпійською системою. У разі спору рішення головного судді є остаточним.',
    day25: '25 вересня',
    day26: '26 вересня',
    day27: '27 вересня',
  },

  info: {
    heroTitle: 'Інформація',
    contactsTitle: 'Контакти та розташування',
    director: 'Директор турніру:',
    contactPerson: 'Контактна особа:',
    phoneNumber: 'Телефон:',
    email: 'Email:',
    venue: 'Місце проведення:',
    transportTitle: 'Трансфер',
    transportIntro: 'Організатор надає платний трансфер із:',
    transportDetails: 'Надішліть деталі своєї подорожі якнайшвидше на sj.bedminton@gmail.com. Оплата трансферу — банківським переказом до турніру або готівкою (EUR) організатору під час турніру.',
    transportWalking: 'Усі офіційні готелі розташовані в пішій доступності від зали, тому трансфер між залою та готелями не надається.',
    mealsDesc: 'Ресторан є частиною зали. Обіди та вечері подаються у форматі шведського столу з різноманітними стравами – all you can eat:',
    transportBa: 'Аеропорт БРАТИСЛАВА = 30 € / особа / в один бік',
    transportVie: 'Аеропорт ВІДЕНЬ = 40 € / особа / в один бік',
    accomTitle: 'Проживання',
    accomOrder: 'Житло замовляється безпосередньо через нашу онлайн-форму бронювання.',
    accomPayment: 'Проживання оплачується банківським переказом до турніру або готівкою (EUR) організатору одразу після прибуття до спортивної зали. Оплата за номер, а не за особу.',
    breakfastIncluded: 'Сніданок включено',
    doubleRoom85: 'Двомісний номер = 85 €/ніч',
    tripleRoom100: 'Тримісний номер = 100 €/ніч',
    fourRoom110: 'Чотиримісний номер = 110 €/ніч',
    doubleRoom95: 'Двомісний номер = 95 €/ніч',
    tripleRoom110: 'Тримісний номер = 110 €/ніч',
    singleRoom65: 'Одномісний номер = 65 €/ніч',
    apartment170: 'Апартаменти (2–4 особи) = 170 €/ніч',
    apartmentMinStay: 'Мінімальне проживання = 3 ночі. Сніданок включено.',
    apartmentDesc: 'Апартаменти включають: 2 окремі двомісні кімнати, ванну, кухню, вітальню, пральну машину.',
    distVenue: 'Безпосередньо в місці проведення.',
    dist14: '1,4 км від зали.',
    dist19: '1,9 км від зали.',
    servicesTitle: 'Інші послуги',
    stringing: 'Перетяжка ракеток:',
    stringingAvail: 'Доступно протягом усього турніру:',
    stringingOnly: 'Перетяжка = 10 €',
    stringingNew: 'Перетяжка + нова струна = 18 €',
    meals: 'Харчування:',
    lunch: 'Обід = 12 €',
    dinner: 'Вечеря = 12 €',
  },

  booking: {
    headerTitle: 'Бронювання житла',
    headerSub: 'Slovak Junior & Youth · Тренчин',
    step1Title: 'Оберіть турнір',
    underAge: (age) => `До ${age} років`,
    contactTitle: 'Контактні дані',
    firstName: "Ім'я",
    lastName: 'Прізвище',
    phone: 'Телефон',
    email: 'Email',
    emailInvalid: 'Введіть дійсну адресу електронної пошти',
    selectCountry: 'Оберіть країну',
    searchCountry: 'Пошук країни…',
    chooseHotel: 'Оберіть готель',
    checkingAvail: 'перевірка доступності…',
    availUnknown: 'Не вдалося перевірити доступність — показані числа можуть бути неактуальними.',
    unavailable: 'Немає місць',
    selfCatering: 'Без харчування',
    breakfast: 'Сніданок включено',
    atVenue: 'У місці проведення · 0 км',
    fromVenue14: '1,4 км від зали',
    fromVenue19: '1,9 км від зали',
    rooms: 'Номери',
    perNight: '€ / ніч',
    addRoom: 'Додати номер',
    soldOut: 'Розпродано',
    minNights3: 'Для апартаментів мінімальне проживання — 3 ночі.',
    noRoomsLeft: 'У цьому готелі вже немає вільних номерів',
    onlyRoomsLeft: (n) => `У цьому готелі ${n === 1 ? 'залишився лише 1 номер' : `залишилося лише ${n} номери`}`,
    roomsAvailable: (n, total) => `Вільні номери: ${n} з ${total}`,
    selectedRooms: 'Обрані номери',
    remove: 'Видалити',
    checkin: 'Заїзд',
    checkout: 'Виїзд',
    nights: (n) => {
      if (n === 1) return '1 ніч';
      const d = n % 10, h = n % 100;
      if (d >= 2 && d <= 4 && !(h >= 12 && h <= 14)) return `${n} ночі`;
      return `${n} ночей`;
    },
    personFirst: (i) => i === 1 ? "Ім'я (особа 1)" : `Ім'я (особа ${i}, необов'язково)`,
    personLast: (i) => i === 1 ? 'Прізвище (особа 1)' : `Прізвище (особа ${i}, необов'язково)`,
    addAnotherRoom: 'Додати ще один номер',
    summaryTitle: 'Підсумок бронювання',
    tournamentLabel: 'Турнір:',
    hotelLabel: 'Готель:',
    contactLabel: 'Контакт:',
    phoneLabel: 'Телефон:',
    emailLabel: 'Email:',
    person: 'Особа',
    estimatedTotal: 'Разом',
    paymentNote: 'Оплата банківським переказом до турніру або готівкою (EUR) після прибуття. Оплата за номер, а не за особу.',
    overFull: (hotel) => `${hotel} щойно розпродано — поверніться назад і оберіть інший готель.`,
    overSome: (n, hotel, remove) => `У готелі ${hotel} ${n === 1 ? 'залишився лише 1 номер' : `залишилося лише ${n} номери`} — видаліть ${remove} ${remove === 1 ? 'номер' : 'номери'} або оберіть інший готель.`,
    btnContact: 'Контактні дані',
    btnHotel: 'Обрати готель',
    btnRoom: 'Обрати номер',
    btnGuests: 'Додати гостей',
    btnReview: 'Підсумок і надсилання',
    btnSubmit: 'Надіслати бронювання',
    btnSubmitting: 'Надсилання…',
    btnBack: 'Назад',
    btnClose: 'Закрити',
    successTitle: 'Бронювання надіслано!',
    successText: 'Ваш запит на проживання отримано. Організатор підтвердить його та надішле платіжні інструкції на вашу електронну пошту.',
    confirmHotelChange: 'Зміна готелю видалить обрані номери. Продовжити?',
    submitError: 'На жаль, під час надсилання бронювання сталася помилка. Спробуйте ще раз.',
    roomTypes: {
      'Single room': 'Одномісний номер',
      'Double room': 'Двомісний номер',
      'Triple room': 'Тримісний номер',
      '4-person room': 'Чотиримісний номер',
      'Apartment (2-4 persons)': 'Апартаменти (2–4 особи)',
    },
  },

  reg: {
    notOpen: 'Реєстрацію ще не відкрито.',
    headerTitle: 'Реєстрація на турнір',
    step1Title: 'Клуб і контакт',
    club: 'Назва клубу',
    country: 'Країна',
    managerTitle: 'Керівник команди',
    singlesTitle: 'Заявки — одиночні',
    doublesTitle: 'Заявки — парні',
    addSingles: 'Додати гравця (одиночний)',
    addDoubles: 'Додати пару (парний)',
    noEntries: 'Поки що немає заявок — цей крок можна пропустити.',
    player1: 'Гравець 1',
    player2opt: 'Гравець 2 (необовʼязково)',
    partnerNote: 'Заявка на парний розряд дійсна навіть з одним гравцем — партнера можна додати пізніше.',
    discipline: 'Розряд',
    disciplines: {
      BS: 'Одиночний — хлопці',
      GS: 'Одиночний — дівчата',
      BD: 'Парний — хлопці',
      GD: 'Парний — дівчата',
      XD: 'Змішаний парний',
    },
    summaryTitle: 'Підсумок реєстрації',
    clubLabel: 'Клуб:',
    entriesLabel: 'Заявки:',
    entriesCount: (n) => {
      const d = n % 10, h = n % 100;
      if (d === 1 && h !== 11) return `${n} заявка`;
      if (d >= 2 && d <= 4 && !(h >= 12 && h <= 14)) return `${n} заявки`;
      return `${n} заявок`;
    },
    needOneEntry: 'Перед надсиланням додайте принаймні одну заявку (одиночний або парний розряд).',
    btnSingles: 'Одиночні',
    btnDoubles: 'Парні',
    btnSubmit: 'Надіслати реєстрацію',
    successTitle: 'Реєстрацію надіслано!',
    successText: 'Ваші заявки отримано. Організатор підтвердить реєстрацію електронною поштою.',
  },
};

export default uk;
